// extracted by mini-css-extract-plugin
module.exports = {"header":"_1qRDB","logo":"NI9Rf","stripeForm":"_8pcgS","stripeForm-container":"QGTsb","stripeForm-items":"Qx8Rs","loader":"fSITb","cardsOnFile-item":"lysOx"};